import { useQuery } from '@tanstack/react-query';
import { getRoleById } from '@services/rbac.service';

export const ROLE_DETAIL_QUERY_KEY = (id) => ['rbac', 'role', id];

export const useRoleDetail = (roleId) =>
    useQuery({
        queryKey: ROLE_DETAIL_QUERY_KEY(roleId),
        queryFn: () => getRoleById(roleId),
        enabled: !!roleId,
    });

/**
 * Group permissions by module for display. Returns array of { module, permissions } sorted by module name.
 * @param {Array<{ module?: string, feature?: string, action?: string, key?: string, id?: string }>} permissions
 * @returns {Array<{ module: string, permissions: Array }>}
 */
export function groupPermissionsByModule(permissions) {
    if (!Array.isArray(permissions)) return [];
    const byModule = {};
    for (const p of permissions) {
        const m = p.module || 'other';
        if (!byModule[m]) byModule[m] = [];
        byModule[m].push(p);
    }
    return Object.entries(byModule)
        .sort(([a], [b]) => a.localeCompare(b))
        .map(([module, perms]) => ({ module, permissions: perms }));
}
